import { useEffect } from "react"
import { Navigate } from "react-router-dom"
import Auth from "@aws-amplify/auth"

import { Page } from "components"
import { clearHostedUIReturnRoute } from "auth/hostedUI"

const HomePage = history => {
  useEffect(() => {
    clearHostedUIReturnRoute()
    Auth.signOut()
  }, [])
  return (
    <Page title="Logout">
      <Navigate replace to="/" />
    </Page>
  )
}

export default HomePage
